function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIllegalParking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_101)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 146,
    fill: "#F2A633",
    fillOpacity: 0.6,
    stroke: "#F2A633",
    style: {
      fill: "#F2A633",
      fill: "color(display-p3 0.9490 0.6510 0.2000)",
      fillOpacity: 0.6,
      stroke: "#F2A633",
      stroke: "color(display-p3 0.9490 0.6510 0.2000)",
      strokeOpacity: 1
    },
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_150_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.5 77C110.511 77 78 109.511 78 149.5C78 189.489 110.511 222 150.5 222C190.489 222 223 189.489 223 149.5C223 109.511 190.489 77 150.5 77ZM197.358 188.268L175.074 165.832C171.411 168.121 167.289 169.495 163.016 169.953L189.421 196.358C178.432 205.516 164.695 210.4 150.653 210.4C116.921 210.4 89.6 183.079 89.6 149.5C89.6 135.458 94.6368 121.721 103.642 110.732L125.621 132.711V116.532L111.732 102.642C122.721 93.4842 136.458 88.6 150.5 88.6C184.079 88.6 211.4 115.921 211.4 149.5C211.4 163.542 206.516 177.279 197.358 188.268Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.132 113.784H135.084C134.321 113.784 133.71 114.395 133.71 115.31V186.132C133.71 186.895 134.321 187.658 135.084 187.658H145.005C145.768 187.658 146.379 187.047 146.379 186.132V162.474H158.437C164.847 162.474 170.953 159.879 175.532 155.3C180.11 150.721 182.705 144.616 182.705 138.205C182.858 124.774 171.563 113.784 158.132 113.784ZM166.679 146.142C164.542 148.279 161.642 149.5 158.589 149.5H146.532V126.605H158.589C164.847 126.605 170.037 131.795 170.037 138.053C170.037 141.105 168.816 144.005 166.679 146.142Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_150_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 145,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(78 77)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIllegalParking);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/illegal_parking.16279c7e28b98c17f89a48313a66d587.svg";